import { HTMLProps, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './SidebarSectionRoot.module.css';

export type SidebarSectionRootProps = HTMLProps<HTMLDivElement>;

const SidebarSectionRoot = forwardRef<HTMLDivElement, SidebarSectionRootProps>(
  (props, ref) => {
    const { className, children, ...rest } = props;

    return (
      <div
        ref={ref}
        data-testid="sidebar-section"
        className={classNames(className, styles.root)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

SidebarSectionRoot.displayName = 'SidebarSection.Root';

export default SidebarSectionRoot;
